import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";

import { getCompaniesResourcePath } from "../../resources/company/companyResourceConsts";
import { companyResourceStruct } from "../../resources/company/companyResourceStruct";

export const getCompaniesQuery = (jsonApi: JsonApiClient, userId: string) => {
  return jsonApi.getMany({
    path: getCompaniesResourcePath(userId),
    responseStruct: getCompaniesResponseStruct,
  });
};

const getCompaniesResponseStruct = createResponseStruct({
  data: sup.array(companyResourceStruct),
});

export type GetUserResponse = sup.Infer<typeof getCompaniesResponseStruct>;
